/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Export_Field_Pattern_FilterInputs */



/**
* | output |
* | --- |
* | "Pattern Filter" |
*
* @param {Audit_Export_Field_Pattern_FilterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_export_field_pattern_filter = /** @type {((inputs?: Audit_Export_Field_Pattern_FilterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Export_Field_Pattern_FilterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Musterfilter")
	return /** @type {LocalizedString} */ ("Pattern Filter")
});